import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/differenceInCalendarYears/index.js';

var require$$39 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$39 as default };
